import React from 'react';
import PageHeader from '../components/PageHeader';
import Portfolio from '../components/Portfolio';
import ClientGroups from '../components/ClientGroups';
import CtaBand from '../components/CtaBand';
import usePageMeta from '../utils/usePageMeta';

const PortfolioPage = () => {
  usePageMeta('Our Work: Websites & Digital Presence for Institutes', 'Websites and digital presence by Fedigma for Advance Forte, EduMerit, IBS Bank Career, GAIL Officers Association, FoldX and more, plus our ERP EdTrack Smart.');

  return (
    <>
      <PageHeader
        eyebrow="Our work"
        title="Work we're proud of."
        subtitle="Websites, our own ERP and digital presence for coaching institutes, schools, kindergartens, associations and businesses."
      />
      <Portfolio />
      <ClientGroups alt />
      <CtaBand title="Want results like these?" />
    </>
  );
};

export default PortfolioPage;
